import classNames from 'classnames';
import { ReactNode } from 'react';

export interface LearnLinkProps {
  icon: ReactNode;
  label: string;
  href?: string;
}

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

// "Learn more" link with a soft-blue icon chip, underlined label and a nudging
// arrow. Shared by the FeatureRow rows (Sections 10–12) and Section 19.
export const LearnLink = ({ icon, label, href }: LearnLinkProps) => (
  <a href={href ?? '#'} className={styles.link}>
    <span className={styles.icon}>{icon}</span>
    <span className={styles.text}>{label}</span>
    <span className={styles.arrow}>
      <ArrowIcon />
    </span>
  </a>
);

const styles = {
  link: classNames(
    'group inline-flex w-fit items-center gap-[10px] text-[15px] font-semibold',
    'text-mf-off-black-600 marketing-dark:text-white',
  ),
  icon: classNames(
    'flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-[7px]',
    'bg-[#EBF0F7] marketing-dark:bg-[rgba(127,168,255,0.16)]',
    '[&>svg]:h-3.5 [&>svg]:w-3.5 [&>svg]:fill-none [&>svg]:stroke-2',
    '[&>svg]:stroke-mf-blue marketing-dark:[&>svg]:stroke-[#9cc0ff]',
  ),
  text: classNames(
    'border-b-[1.5px] pb-0.5 transition-colors',
    'border-mf-gray-300 group-hover:border-mf-off-black-600',
    'marketing-dark:border-white/25 marketing-dark:group-hover:border-white',
  ),
  arrow: classNames(
    'transition-transform group-hover:translate-x-[3px]',
    '[&>svg]:h-3.5 [&>svg]:w-3.5 [&>svg]:stroke-[2.2]',
    '[&>svg]:stroke-mf-blue marketing-dark:[&>svg]:stroke-[#9cc0ff]',
  ),
};
